<template>
  <a-config-provider :locale="locale">
    <!--@mousemove="moveEvent" @click="moveEvent"-->
    <div id="app">
      <div class="not-chrome" v-if="showInfo"><i class="info"></i>为了更好的浏览体验，建议使用谷歌浏览器。<a-icon @click="closeFun" class="close" type="close" /></div>
      <router-view :key="this.$route.path" v-if="showState" />
    </div>
  </a-config-provider>
</template>

<script>
  // import enquireScreen from './utils/device'
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  export default {
    name: 'App',
    data() {
      return {
        locale: zhCN,
        timmer: null,
        showState: true,
        showInfo: false
      }
    },
    provide(){
      return {
        reload:this.reload
      }
    },
    created() {
      // let _this = this
      // enquireScreen(isMobile => {
      //   _this.$store.commit('setting/setDevice', isMobile)
      // })
      // this.moveEvent()
    },
    mounted() {
      console.log(window.navigator.userAgent)
      let ua = window.navigator.userAgent;
      this.showInfo = !(ua.indexOf("Chrome") > -1 && ua.indexOf("Edge") < 0 && ua.indexOf("Edg") < 0);  // 是否是谷歌 
      if (!this.commonsVariable.isMathjaxConfig) { // 判断是否初始配置，若无则配置。
        this.commonsVariable.initMathjaxConfig()
      }
      this.commonsVariable.MathQueue('mathJax_latex_wrapper') // 传入组件id，让组件被MathJax渲染 math-tex mathJax_latex_wrapper
    },
    methods: {
      reload(){
        this.showState = false;
        this.$nextTick(()=>{
          this.showState = true;
        })
      },
      closeFun(){
        this.showInfo = false;
      }
      // moveEvent () {
      //   let path = ['/login']
      //   if (!path.includes(this.$route.path)) {
      //     clearTimeout(this.timmer)
      //     this.init()
      //   }
      // },
      // init () {
      //   this.timmer = setTimeout(() => {
      //     // 清除session
      //     localStorage.removeItem('sessionData')
      //     localStorage.clear()
      //     // 清除缓存
      //     this.$cache.reset()
      //     // 跳往登录页面
      //     this.$router.push({
      //       path: '/login'
      //     })
      //   }, 1 * 60 * 1000)
      // }
      //
    }
  }
</script>

<style lang="less">
  body {
    font-family: PingFangSC-Medium;
    min-width: 1280px;
  }

  .not-chrome {
    height: 50px;
    line-height: 50px;
    background: #FBF2D1;
    font-size: 16px;
    color: #666;
    padding: 0 100px;
    .close {
      font-size: 20px;
      float: right;
      margin-top: 15px;
      cursor: pointer;
    }
    .info {
      display: inline-block;
      height: 20px;
      width: 20px;
      background: url(assets/image/icon_info.png);
      background-size: contain;
      margin-right: 8px;
      vertical-align: -4px;
    }
  }

  /* Modal头部样式 */
  .ant-modal-root .ant-modal-content .ant-modal-header {
    height: 40px;
    padding: 9px 14px;
    background: rgba(15,177,181,.7);
  }
  /* drawer头部样式 */
  .ant-drawer .ant-drawer-content .ant-drawer-header {
    height: 48px;
    padding: 9px 14px;
    background: rgba(46,170,254,1);
    border-radius: 0;

    .ant-drawer-title {
      color: white;
      margin-top: 3px;
    }
  }
  .ant-drawer .ant-drawer-content .ant-drawer-header .ant-drawer-close {
    margin-top: -3px;
    color: white;
  }
  .ant-modal-title {
    color: #fff !important;
  }

  .ant-modal-root .ant-modal-content .ant-modal-close-x {
    line-height: 40px;
    color: #fff;
  }

  .ant-modal-root .ant-modal-footer {
    text-align: center;
    border: none;
  }

  /* 分页 */
  .ant-pagination {
    text-align: center;
    white-space: nowrap;
  }

  ul li {
    list-style: none;
  }

  /* :global { */
  /* 拖拽控件全局样式 */
  .dragable-ghost {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }

  .dragable-chose {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }

  .dragable-drag {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }

  /* 页面切换动画 */
  .page-toggle-enter-active {
    transition: all 0.2s ease-in 0.25s;
  }

  .page-toggle-leave-active {
    transition: all 0.2s ease-out 0s;
  }

  .page-toggle-enter,
  .page-toggle-leave-to {
    opacity: 0;
    padding: 0px;
  }

  table .ant-table-thead>tr>th {
    font-weight: bold;
    color: rgba(0,0,0,.85);
    white-space: nowrap;
  }

  /* } */
  /* 公共公式样式 */
  /deep/ .MathJax {
    display: inline-flex;
    align-items: center;
  }


  .showPopover {
    display: none !important;
  }

  .required {
    position: relative;

    &::before {
      position: absolute;
      content: '*';
      top: 1px;
      left: -8px;
      color: red;
    }
}
.ant-table-content {
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/App.vue